var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHousing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 7C12.6875 5.49158 12.0883 4.04494 11.0217 2.97833C9.95506 1.91172 8.50842 1.3125 7 1.3125C5.49158 1.3125 4.04494 1.91172 2.97833 2.97833C1.91172 4.04494 1.3125 5.49158 1.3125 7C1.3125 8.50842 1.91172 9.95506 2.97833 11.0217C4.04494 12.0883 5.49158 12.6875 7 12.6875C8.50842 12.6875 9.95506 12.0883 11.0217 11.0217C12.0883 9.95506 12.6875 8.50842 12.6875 7ZM0 7C0 5.14348 0.737498 3.36301 2.05025 2.05025C3.36301 0.737498 5.14348 0 7 0C8.85652 0 10.637 0.737498 11.9497 2.05025C13.2625 3.36301 14 5.14348 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14C5.14348 14 3.36301 13.2625 2.05025 11.9497C0.737498 10.637 0 8.85652 0 7ZM5.90625 7.4375H7.65625C8.38086 7.4375 8.96875 6.84961 8.96875 6.125C8.96875 5.40039 8.38086 4.8125 7.65625 4.8125H5.90625V7.4375ZM7.65625 8.75H5.90625V9.84375C5.90625 10.2074 5.61367 10.5 5.25 10.5C4.88633 10.5 4.59375 10.2074 4.59375 9.84375V4.375C4.59375 3.89102 4.98477 3.5 5.46875 3.5H7.65625C9.10547 3.5 10.2812 4.67578 10.2812 6.125C10.2812 7.57422 9.10547 8.75 7.65625 8.75Z",
    fill: "#01152E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHousing);
export default __webpack_public_path__ + "static/media/icon-housing.e15d38e5e74c354737235db0cf1583d4.svg";
export { ForwardRef as ReactComponent };